import PlayVideoComponent from './play-video.component'

export default  PlayVideoComponent
